import { GET_REFERENT_ADVISERS } from '../mutation-types'

const state = { all: [] }

const mutations = {
  [GET_REFERENT_ADVISERS] (state, referentAdvisers) {
    state.all = referentAdvisers
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/referentAdvisers.js